<template>
  <div class="episode_db_box">
    <app-input :placeholder="translations.enterLink" />
    <p class="field field_all">
      <app-checkbox :title="translations.all" />
      <app-button-move />
    </p>
    <app-checkbox :title="translations.ignoreSeasons" field />
    <div class="episode_db_box_scroll">
      <div class="series_box" v-for="seriesNum in Object.keys(series)" :key="seriesNum">
        <app-checkbox :title="translations.season + ' ' + seriesNum.padStart(2, '0')" field series />
          <app-checkbox
              v-for="episode in series[seriesNum]"
              :key="episode._id"
              episode
              :title="episode.episodeNumber + '. ' + episode.name"
          >
            {{ episode.description }}
          </app-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarDropdown from './Sidebar/SidebarDropdown'

export default {
  name: 'sidebar-series-list',
  components: {
    SidebarDropdown
  },
  props: {
    series: {
      type: Object,
      required: true
    }
  },
  computed: {
    translations() {
      return {
        enterLink: this.$gettext('Vložte odkaz'),
        all: this.$gettext('Vše'),
        ignoreSeasons: this.$gettext('Ignorovat série'),
        season: this.$gettext('SÉRIE'),
      }
    }
  }
}
</script>
